import { ClientsComponent } from "@/features";
import { EsoClient } from "@/types";

interface Props {
  isLoading: boolean
  clients: EsoClient[]
}

export const ClientsPage = ({ isLoading, clients }: Props) => {
  return <ClientsComponent isLoading={isLoading} clients={clients} />;
}